module.exports = __webpack_public_path__ + "static/media/BB_howtoboost_Desktop_EN.3c39852b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BB_howtoboost_Desktop_EN.png
// module id = 710
// module chunks = 0